import React, { useState } from "react";
import moment from "moment";
import _ from "lodash";
import cx from "classnames";
import XLSX from "xlsx";
import { FileDownloadOutlined } from "@mui/icons-material";
import { Fields } from "./shared/Fields";

const DownloadErrors = ({
  submissionType,
  attachments,
  className,
  label = (
    <>
      <FileDownloadOutlined style={{ fontSize: "18px", verticalAlign: "text-bottom" }} /> Download
      Error Rows
    </>
  ),
}) => {
  const FILENAME_PREFIXES = {
    pharmacy: "340B_ESP_Pharmacy",
    medical: "340B_ESP_Medical",
    pharmacy_encounter: "340B_ESP_Pharmacy_Encounter",
    medical_encounter: "340B_ESP_Medical_Encounter",
  };
  const filenamePrefix = FILENAME_PREFIXES[submissionType] || "340B_ESP";
  const [downloading, setDownloading] = useState(false);

  const buildWorkbook = () => {
    const workbook = XLSX.utils.book_new();
    const headers = _.keys(Fields[submissionType]);
    const sheet = XLSX.utils.aoa_to_sheet([headers]);

    _.forEach(attachments, (file, index) => {
      XLSX.utils.sheet_add_json(sheet, file.errorRowsForExport, {
        skipHeader: true,
        blankrows: false,
        origin: index === 0 ? "A2" : -1,
      });
    });

    XLSX.utils.book_append_sheet(workbook, sheet, "340B ESP™");
    return workbook;
  };

  const handleDownload = () => {
    setDownloading(true);

    const workbook = buildWorkbook();
    XLSX.writeFile(
      workbook,
      `${filenamePrefix}_${moment().format("YYYY-MM-DD_HH-mm-ss")}_alerts.csv`
    );

    setDownloading(false);
  };

  const hasErrors = attachments.some((file) => file?.hasErrors);

  return (
    <button
      className={cx(
        { "btn btn--outline btn--white": !className },
        { "btn--disabled": !hasErrors },
        className
      )}
      disabled={!hasErrors}
      onClick={hasErrors ? handleDownload : undefined}
    >
      {downloading && <div className="loading-indicator"></div>}
      {label}
    </button>
  );
};

export default DownloadErrors;
